/**
 * Kampanya bağlantısı oluşturucu (F5-13). UTM değerleri raporlarda tek yazımla toplansın diye küçük harfe,
 * Türkçe karakterler Latin karşılıklarına, boşluklar tireye çevrilir; harf, rakam, tire, alt çizgi ve nokta
 * dışındaki karakterler atılır.
 */

const TR: Record<string, string> = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', â: 'a', î: 'i', û: 'u' };

export function utmValue(v: string): string {
  return v
    .trim()
    .toLocaleLowerCase('tr-TR')
    .replace(/[çğıöşüâîû]/g, (c) => TR[c] ?? c)
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9._-]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 100);
}

export interface UtmInput {
  url: string;
  source: string;
  medium: string;
  campaign: string;
  term?: string;
  content?: string;
}

/** Hazır bağlantı; adres geçersizse veya zorunlu alan boşsa null. Adresteki diğer parametreler korunur. */
export function campaignUrl(i: UtmInput): string | null {
  let u: URL;
  try {
    u = new URL(i.url.trim());
  } catch {
    return null;
  }
  if (u.protocol !== 'https:' && u.protocol !== 'http:') return null;
  const values: Array<[string, string]> = [
    ['utm_source', utmValue(i.source)],
    ['utm_medium', utmValue(i.medium)],
    ['utm_campaign', utmValue(i.campaign)],
    ['utm_term', utmValue(i.term ?? '')],
    ['utm_content', utmValue(i.content ?? '')],
  ];
  if (!values[0]![1] || !values[1]![1] || !values[2]![1]) return null;
  for (const [k] of values) u.searchParams.delete(k);
  for (const [k, v] of values) if (v) u.searchParams.set(k, v);
  return u.toString();
}

export const UTM_SOURCES = [
  'google',
  'facebook',
  'instagram',
  'tiktok',
  'youtube',
  'newsletter',
  'whatsapp',
  'sms',
];
export const UTM_MEDIUMS = [
  'cpc',
  'paid_social',
  'social',
  'email',
  'sms',
  'referral',
  'display',
  'affiliate',
  'qr',
];
